import React, { Component } from "react";
import { Flex, Box } from "grid-styled";
import { Collapse } from "react-collapse";

import { Heading, Clickable, Text, FlexWithHeight } from "../globals";
import Icon from "../Icon";
import Rotate from "../Rotate";
import DesignersPreview from "../DesignersPreview";
import RecommendationList from "../RecommendationList";

class BookListItem extends Component {
    state = {
        visibility: "hidden",
        isOpened: false,
        blockOnRest: false
    };

    toggleAccordion = () => {
        if (!this.state.isOpened) {
            this.setState(
                {
                    blockOnRest: true
                },
                () => {
                    this.setState(
                        {
                            visibility: "visible"
                        },
                        () => {
                            this.setState(
                                {
                                    isOpened: true
                                },
                                () => {
                                    this.setState({
                                        blockOnRest: false
                                    });
                                }
                            );
                        }
                    );
                }
            );
        } else {
            this.setState({
                isOpened: false
            });
        }
    };

    ensureIsHidden = () => {
        if (
            !this.state.isOpened &&
            this.state.visibility === "visible" &&
            !this.state.blockOnRest
        ) {
            this.setState({
                visibility: "hidden"
            });
        }
    };

    render() {
        const { book } = this.props;
        const { authors, recommendations } = book;
        const designers = recommendations.map(({ designer }) => designer);

        // Might need to be a single span
        let authorNames = `by ${authors[0].firstName} ${authors[0].lastName}`;

        if (authors.length === 2) {
            authorNames = `${authorNames} and ${authors[1].firstName} ${
                authors[1].lastName
            }`;
        } else {
            for (let i = 1; i < authors.length; i++) {
                authorNames = `${authorNames}, ${authors[i].firstName} ${
                    authors[i].lastName
                }`;
            }
        }

        return (
            <div>
                <Clickable
                    onClick={this.toggleAccordion}
                    px={4}
                    py={4}
                    aria-controls={`book-${book.id}`}
                    aria-expanded={this.state.isOpened ? "true" : "false"}
                >
                    <Flex justifyContent="space-between">
                        <Box mr={6}>
                            <Flex flexDirection="column">
                                <Heading is="h2" fontSize={4} lineHeight="1.2">
                                    {book.subtitle
                                        ? `${book.title}: ${book.subtitle}`
                                        : book.title}
                                </Heading>
                                <Text is="span" color="#3D3D3D">
                                    {authorNames}
                                </Text>
                            </Flex>
                            <Flex pt={3} alignItems="center">
                                <DesignersPreview designers={designers} />
                            </Flex>
                        </Box>
                        <FlexWithHeight
                            alignItems="center"
                            justifyContent="center"
                            height={25}
                        >
                            <Rotate
                                transform={
                                    this.state.isOpened
                                        ? "rotate(-180deg)"
                                        : "rotate(0deg)"
                                }
                            >
                                <Icon
                                    glyph="expandMore"
                                    size={16}
                                    color="#A3A3A3"
                                />
                            </Rotate>
                        </FlexWithHeight>
                    </Flex>
                </Clickable>

                <Collapse
                    isOpened={this.state.isOpened}
                    aria-hidden={this.state.isOpened ? "false" : "true"}
                    id={`book-${book.id}`}
                    style={{ visibility: this.state.visibility }}
                    onRest={this.ensureIsHidden}
                >
                    <RecommendationList book={book} />
                </Collapse>
            </div>
        );
    }
}

export default BookListItem;



// WEBPACK FOOTER //
// ./src/components/BookListItem/index.js